import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=629aa649&scoped=true"
import script from "./Contacts.vue?vue&type=script&setup=true&lang=ts"
export * from "./Contacts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=629aa649&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629aa649",
  null
  
)

export default component.exports